/*
 * @Author: Auto Generated
 * @FilePath: /mall-fe/src/hooks/useRuntimeConfigurationQuery.ts
 * @Description: 运行时配置查询 Hook
 *
 * 使用 React Query 在客户端获取运行时配置数据
 * 包括 OSS、OBS、静态资源域名等配置
 */

import { useQuery } from '@tanstack/react-query';
import { getRuntimeConfiguration } from 'api/user';
import { queryKeys } from 'libs/react-query';

/**
 * 使用 React Query 获取运行时配置数据
 *
 * @param options - 查询选项
 * @param options.enabled - 是否启用查询（默认为 true）
 * @param options.initialData - 初始数据（可选，用于服务端渲染场景）
 *
 * @returns 返回查询结果对象，包含：
 *   - data: 运行时配置数据数组
 *   - isLoading: 是否正在首次加载
 *   - isFetching: 是否正在获取数据（包括后台更新）
 *   - isError: 是否发生错误
 *   - error: 错误信息
 *   - refetch: 手动重新获取数据的函数
 *
 * @example
 * ```tsx
 * function ImageUploader() {
 *   const { data: runtimeConfig, isLoading } = useRuntimeConfigurationQuery();
 *
 *   const ossHost = runtimeConfig?.find(item => item.key === 'oss')?.value;
 *
 *   if (isLoading) return <div>加载中...</div>;
 *
 *   return <Uploader uploadUrl={ossHost} />;
 * }
 * ```
 */
export function useRuntimeConfigurationQuery(options?: { enabled?: boolean; initialData?: any[] }) {
  const { enabled = true, initialData } = options || {};
  return useQuery({
    // 查询键，用于缓存和标识查询
    queryKey: queryKeys.runtimeConfiguration.list(),

    // 查询函数，返回 Promise
    queryFn: async () => {
      try {
        const res = await getRuntimeConfiguration({});

        if (res.code === 200) {
          return res.data || [];
        }

        throw new Error(res.message || '获取运行时配置失败');
      } catch (error) {
        console.error('获取运行时配置数据失败:', error);
        throw error;
      }
    },

    // 是否启用查询
    enabled,

    // 初始数据（用于服务端渲染场景）
    initialData,

    // 失败时重试1次
    retry: 1,
  });
}
